import styled from 'styled-components';
import Anchor from '../Anchor';
import { Text } from '../Typography';
import Icon from '../Icon';
import theme from '../theme';

export const StyledAnchor = styled(Anchor)`
  background-color: transparent;
  .ant-anchor-ink {
    display: none;
  }
  .ant-anchor-link {
    padding-left: 0;
  }
`;

export const StyledItem = styled.div<{ $active: boolean }>`
  && {
    display: grid;
    align-items: center;
    grid-template-columns: auto auto;
    justify-content: flex-start;
    grid-column-gap: 15px;
    ${Text} {
      font-size: 1.6rem;
      color: ${({ $active }) =>
        theme.getColor($active ? 'textPrimary' : 'textSecondary')};
    }
    ${Icon} {
      background-color: ${theme.getColor('success')};
      border-radius: 50%;
      padding: 2px;
    }
    .unchecked {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: ${theme.gray6};
    }
  }
`;
